import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { MAX_RETRY_COUNT } from 'components/paymentProcessPage/Container/constants';
import React, { useEffect, useState } from 'react';
import { isMobileDevice } from '../../../common/utilities/utils';
import PAYMENT_PROCESS from '../Constants';

const OrderConfirmScreen = props => {
  const {
    CURRENT_ORDER = '',
    PROCESSING = '',
    PROCESSING_YOUR = '',
    ORDER_READY_IN_JUST = '',
    SECOND = '',
    CONFIRMING_YOUR_ORDER = '',
    READY_IN_JUST_A_SECOND = '',
  } = PAYMENT_PROCESS;

  const [isMobile, setMobileFooter] = useState(isMobileDevice(window.innerWidth));

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileFooter(isMobileView);
  };

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  useEffect(() => {
    if (props.retryCount >= 0 && props.retryCount <= MAX_RETRY_COUNT) {
      const progressBarContainer = document.getElementById('progressBarContainer');
      const progressBar = document.getElementById('progressBar');
      console.log(progressBarContainer.offsetWidth);
      const width = (progressBarContainer.offsetWidth / MAX_RETRY_COUNT) * (props.retryCount + 1);
      console.log(width);
      progressBar.style.width = width + 'px';
    }
  }, [props.retryCount]);

  return (
    <div>
      {isMobile ? (
        <div className='orderConfirmScreenMob' data-testid='orderConfirmItems-component'>
          <div className='statusBar'>
            <div className='currentStatusMob'>{translateWithI18Next(CURRENT_ORDER)}</div>

            <div id='progressBarContainer' className='ProgressMob'>
              <div id='progressBar' className='barMob' data-testid='load-component'></div>
            </div>
            <div className='progressBarMob'>{translateWithI18Next(PROCESSING)}</div>
            <div className='confirmOrderMobile'>{translateWithI18Next(PROCESSING_YOUR)}</div>
            <div className='confirmOrderMobile'> {translateWithI18Next(ORDER_READY_IN_JUST)}</div>
            <div className='confirmOrderMobile'> {translateWithI18Next(SECOND)}</div>
          </div>
        </div>
      ) : (
        <div className='orderConfirmScreen' data-testid='orderConfirmItems-component'>
          <div className='statusBar'>
            <div className='currentStatus'>{translateWithI18Next(CURRENT_ORDER)}</div>

            <div id='progressBarContainer' className='Progress'>
              <div id='progressBar' className='bar'></div>
            </div>
            <div className='progressBar'>{translateWithI18Next(PROCESSING)}</div>
            <div className='confirmOrder'>{translateWithI18Next(CONFIRMING_YOUR_ORDER)}</div>
            <div className='confirmOrder'> {translateWithI18Next(READY_IN_JUST_A_SECOND)} </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default OrderConfirmScreen;
